/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from "react";
import * as S from "./styles";
import {
  PURE_BG,
  TRIBE_BG,
  CAL_BG,
  THE_LOST_TRIBE_BG,
  HARTS_BG,
  ROGUE_BG,
  SECRETS_BG,
} from "../../assets";
import { StorageModule } from "@vlinder-web/storage-module-react";
const is = require("is_js");

export interface IColoredBackground { }

export const ColoredBackground = (props: IColoredBackground) => {
  const storageSrv = StorageModule.getInstance();

  const localStorage = storageSrv?.get("currencyExchangeLocal", "local");
  const sessionStorage = storageSrv?.get("currencyExchangeSession", "session");

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "tribe"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${TRIBE_BG})` }} />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "cal"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${CAL_BG})` }} />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "calkids"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${CAL_BG})` }} />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "secrets"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${SECRETS_BG})` }} />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "pure"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${PURE_BG})` }} />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "cal"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${CAL_BG})` }} />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "calkids"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${CAL_BG})` }} />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "the lost tribe"
  ) {
    return (
      <S.ColouredBackground
        style={{ backgroundImage: `url(${THE_LOST_TRIBE_BG})` }}
      />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "harts"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${HARTS_BG})` }} />
    );
  } else if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "rogue"
  ) {
    return (
      <S.ColouredBackground style={{ backgroundImage: `url(${ROGUE_BG})` }} />
    );
  }

  return (
    <S.ColouredBackground style={{ backgroundImage: `url(${CAL_BG})` }} />
  );
};

ColoredBackground.defaultProps = {};
